import type {ActiveBusinessCaseResponseBody} from '@dms/api/sales';

export const shouldWarnBeforeCustomerEdit = (
  activeBusinessCases: ActiveBusinessCaseResponseBody[]
) =>
  activeBusinessCases.some(
    (businessCase) =>
      businessCase.businessCaseState !== 'OFFER' &&
      businessCase.businessCaseState !== 'UNSUCCESSFUL'
  );
